import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const Production = () => import('@/views/Production')
const ThreeNav = () => import('@/views/ThreeNav')
const FourNav = () => import('@/views/FourNav')
const FiveNav = () => import('@/views/FiveNav')
const Demo = () => import('@/views/Demo')
const ProductionBrain = () => import('@/components/production/ProductionBrain.vue')
const YunZhaoShang = () => import('@/components/yun_zhaoshang/index.vue')
const EnterInnovation = () => import('@/components/enter_innovation/index.vue')
const Consulting = () => import('@/components/consulting/index.vue')
const ReportList = () => import('@/components/report_list/index.vue')
const NewsDetails = () => import('@/components/report_list/NewsDetails.vue')
const NewsDetailsTwo = () => import('@/components/report_list/NewsDetailsTwo.vue')
const NewsDetailsThree = () => import('@/components/report_list/NewsDetailsThree.vue')
const NewsDetailsFour = () => import('@/components/report_list/NewsDetailsFour.vue')
const NewsDetailsFive = () => import('@/components/report_list/NewsDetailsFive.vue')
const NewsDetailsSix = () => import('@/components/report_list/NewsDetailsSix.vue')
const NewsDetailsSeven = () => import('@/components/report_list/NewsDetailsSeven.vue')
const NewsDetailsEight = () => import('@/components/report_list/NewsDetailsEight.vue')
const NewsDetailsNine = () => import('@/components/report_list/NewsDetailsNine.vue')
const NewsDetailsTen = () => import('@/components/report_list/NewsDetailsTen.vue')
const Realize = () => import('@/components/realize/index.vue')

const routes = [
    {
        path: '',
        redirect: '/home'
    },
    {
        path: '/home',
        component: Home
    },
    {
        path: '/production',
        component: Production,
        children: [
            {
                path: '1',
                component: ProductionBrain
            },
            {
                path: '2',
                component: YunZhaoShang
            },
            {
                path: '3',
                component: EnterInnovation
            },
            {
                path: '4',
                component: Consulting
            }
        ]
    },
    {
        path: '/threenav',
        component: ThreeNav
    },
    {
        path: '/fournav',
        component: FourNav,
        children: [
            {
                path: '1',
                component: ReportList
            },
            {
                path: '2',
                component: ReportList
            },
            {
                path: '3',
                component: ReportList
            },
        ]
    },
    {
        path: '/fivenav',
        component: FiveNav,
        children: [
            {
                path: '1',
                component: Realize
            },
            {
                path: '2',
                component: Realize
            },
            {
                path: '3',
                component: Realize
            },
            {
                path: '4',
                component: Realize
            }
        ]
    },
    {
        path: '/demo',
        component: Demo
    },
    {
        path: '/news_detail/1',
        component: NewsDetails
    },
    {
        path: '/news_detail/2',
        component: NewsDetailsTwo
    },
    {
        path: '/news_detail/3',
        component: NewsDetailsThree
    },
    {
        path: '/news_detail/4',
        component: NewsDetailsFour
    },
    {
        path: '/news_detail/5',
        component: NewsDetailsFive
    },
    {
        path: '/news_detail/6',
        component: NewsDetailsSix
    },
    {
        path: '/news_detail/7',
        component: NewsDetailsSeven
    },
    {
        path: '/news_detail/8',
        component: NewsDetailsEight
    },
    {
        path: '/news_detail/9',
        component: NewsDetailsNine
    },
    {
        path: '/news_detail/10',
        component: NewsDetailsTen
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router